// extracted by mini-css-extract-plugin
module.exports = {"card":"CMS_card__24D11","cmsHeader":"CMS_cmsHeader__2IRoL","title":"CMS_title__1lbQL"};